import { render } from "./AsociaDesasociaRol.vue?vue&type=template&id=d914a806&scoped=true"
import script from "./AsociaDesasociaRol.vue?vue&type=script&lang=js"
export * from "./AsociaDesasociaRol.vue?vue&type=script&lang=js"

import "./AsociaDesasociaRol.vue?vue&type=style&index=0&id=d914a806&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d914a806"]])

export default __exports__